<template>

  <svg
    t="1640066119610"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3996"
    width="64"
    height="64"
  ><path d="M881.90000001 853.10000001H142.09999999c-17.10000001 0-28.8 11.70000001-28.79999998 28.79999998s11.70000001 28.8 28.8 28.8h739.8c17.10000001 0 28.8-11.70000001 28.8-28.8s-11.70000001-28.8-28.8-28.8zM146.6 823.4l243-57.6 419.4-423c9.90000001-9.90000001 15.30000001-22.50000001 15.30000001-36s-5.4-26.10000001-15.30000001-36l-144-144c-10.8-10.8-25.2-15.30000001-35.10000001-15.30000001-14.4 0-25.2 4.50000001-35.99999998 15.30000001L170 551.6 113.29999999 789.2v0.90000001c0 10.8 5.4 21.6 10.80000002 26.99999998 6.30000001 6.30000001 17.10000001 6.30000001 22.49999999 6.30000001zM675.8 395L381.49999999 689.30000001 248.29999999 555.2l289.80000002-289.8L675.8 395zM336.49999999 725.30000001l-162.89999999 37.79999998 37.8-162.89999999 125.10000001 125.10000001zM575 229.4l54.90000001-54.90000001 133.19999998 133.20000002-51.29999999 51.29999999L575 229.4z" p-id="3997" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconEdit',
} as DefineComponent
</script>